import getLegacyStatus from './getLegacyStatus';

const statusOrder = {
  READY_FOR_REVIEW: 1,
  READY_TO_FILE: 2,
  AWAITING_INFORMATION: 3,
  AWAITING_APPROVAL: 4,
  OPEN: 5,
  PREPARING: 6,
  PREPARING_SUBMISSION: 7,
  SUBMITTED_TO_HMRC: 8,
};

const getFilteredSelfAssessments = (data, { search, status }, currentYear) => {
  const selfAssessments =
    data?.assignedSelfAssessments || data?.allSelfAssessments;

  if (!selfAssessments)
    return { selfAssessmentData: [], pastSelfAssessmentData: [] };

  const sortableData = selfAssessments.map((item) => item);

  const sortedData = sortableData.sort((a, b) => {
    const aOrder = statusOrder[getLegacyStatus(a)];
    const bOrder = statusOrder[getLegacyStatus(b)];

    if (aOrder > bOrder) {
      return 1;
    }

    if (aOrder < bOrder) {
      return -1;
    }

    return 0;
  });

  const selfAssessmentData = sortedData.filter(
    (item) =>
      item.taxYear.year === currentYear &&
      (!search ||
        item.user?.name.toLowerCase().includes(search.toLowerCase())) &&
      (!status || getLegacyStatus(item) === status),
  );

  return selfAssessmentData;
};

export default getFilteredSelfAssessments;
